<template>
  <transition name="hearing-alert">
    <div v-if="visible" class="hearing-alert-overlay" @click.self="confirm">
      <div class="hearing-alert" role="alertdialog" aria-modal="true">
        <p class="hearing-alert__message">{{ message }}</p>
        <button type="button" class="hearing-alert__button" @click="confirm">확인</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { alertBus } from '@/plugins/hearingAlert';

export default {
  name: 'HearingAlert',
  data() {
    return {
      visible: false,
      message: '',
      resolveFn: null,
    };
  },
  created() {
    alertBus.$on('hearing-alert:open', this.open);
  },
  beforeDestroy() {
    alertBus.$off('hearing-alert:open', this.open);
  },
  methods: {
    open(payload) {
      this.message = (payload && payload.message) || '';
      this.resolveFn = (payload && payload.resolve) || null;
      this.visible = true;
    },
    confirm() {
      this.visible = false;
      const fn = this.resolveFn;
      this.resolveFn = null;
      if (typeof fn === 'function') fn();
    },
  },
};
</script>

<style scoped>
.hearing-alert-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  //background: rgba(0, 0, 0, 0.25);
  //background: rgba(0, 0, 0, 0.45);
  z-index: 99999;
}

.hearing-alert {
  width: 100%;
  max-width: 360px;
  padding: 36px 28px 24px;
  background: #fff;
  border-radius: 6px;
  text-align: center;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
}

.hearing-alert__message {
  margin: 0 0 28px;
  color: #222;
  font-size: 17px;
  line-height: 1.6;
  white-space: pre-line;
  word-break: keep-all;
}

.hearing-alert__button {
  width: 100%;
  padding: 14px 0;
  border: 0;
  border-radius: 4px;
  background: #222;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.hearing-alert__button:hover {
  opacity: 0.88;
}

.hearing-alert-enter-active,
.hearing-alert-leave-active {
  transition: opacity 0.18s ease;
}

.hearing-alert-enter,
.hearing-alert-leave-to {
  opacity: 0;
}
</style>
